<template>
  <EmptyPhenotypeDialog v-model="emptyPhenotypeOpen" @close="$emit('close')"/>
  <v-card 
    v-if="donorDetails"
    class="pa-4 cart_container flex-wrap"
    :class="{
      'd-flex flex-column justify-start': $vuetify.display.mobile && dialog, 
      'd-flex flex-row justify-space-between wide': !$vuetify.display.mobile && dialog 
    }"
    outlined
    elevation="0"
    rounded="0"
    :color="$vuetify.display.mobile ? 'secondarybg' : 'white'"
    >
    <h3
      class="order-first mt-1 main-header"
      :class="{
        'mb-0': $vuetify.display.mobile && dialog,
        'mb-10': !$vuetify.display.mobile && dialog
      }"
      v-if="dialog && !materialAdded"
    >
      {{$t('cart.add_to_cart_header')}} <br v-if="$vuetify.display.mobile"/> {{$t(`donor.${materialType}.gen`)}}
      <span v-if="dialog"  class="id-wrapper pt-md-4 pt-0 ml-2 ml-md-0 text-left text-md-center">
          <span class="id mt-1">{{ donorDetails.donor_process.donor_nickname }}</span>
      </span>
    </h3>
    <h3
      class="order-first mt-1 main-header d-flex align-center"
      :class="{
        'mb-0': $vuetify.display.mobile && dialog,
        'mb-10': !$vuetify.display.mobile && dialog
      }"
      v-if="dialog && materialAdded"
    >
      <v-icon color="#177E0B" class="mr-2" >mdi-check-circle-outline</v-icon>
      {{$t('cart.added_to_cart_header')}}
    </h3>
    <div v-if="materialType == 'mtCell'" class="order-0">
      <div class="label mt-10 mt-md-0" v-if="dialog">{{$t('reservation.package_type_label')}}</div>
      <div class="name text-left mb-4" :class="{'high': dialog}">
        {{$t('reservation.mtCell.product_name', {size: this.donorDetails.material.package_size})}}
        <div v-if="!dialog" class="label desc mt-2">
          {{$t('reservation.mtCell.product_description')}}
        </div>
      </div>
    </div>
    <div v-else class="order-0">
      <div class="label mt-10 mt-md-0" v-if="dialog">{{$t('reservation.package_type_label')}}</div>
      <p class="name text-left mb-4" :class="{'high': dialog}">
        {{$t('reservation.mtSemen.product_name')}} <span class="bold">'{{$t(this.donorDetails.material.fitness_for_insemination)}}'</span>
        <br>
        <span v-if="!dialog" class="label desc">
          {{$t('reservation.mtSemen.product_description', 
          {procedure: $t(`reservation.mtSemen.procedure_to_description.${donorDetails.material.fitness_for_insemination}`)})}}
        </span>
      </p>
    </div>
    <div :class="['order-2', {'mt-9': !dialog && !mzGrantFileId}]">
      <div
        class="label mt-6 mt-md-0"
        :class="{
          'text-right': !$vuetify.display.mobile && dialog,
          'mb-2': dialog && mzGrantFileId && !materialAdded,
          'mb-4': !mzGrantFileId && $vuetify.display.mobile && !materialAdded
        }"
        v-if="dialog"
      >{{$t('reservation.summary_label')}}</div>
      <p 
        v-if="prices && (!materialAdded || !dialog)"
        :class="['name price text-left d-flex flex-column', {'high text-right': dialog && !$vuetify.display.mobile}]"
      >
        <span :class="{'no-refund': mzGrantFileId}">
          {{ $n(prices[materialType].price_brutto * quantity, 'currency', 'pl') }}
        </span>
        <span 
          v-if="mzGrantFileId" :class="['price-with-refund', {'mb-2': dialog && !$vuetify.display.mobile}]"
        >
          {{ $n(prices[materialType].price_brutto * (quantity-1), 'currency', 'pl') }}
        </span>
      </p>
      <p 
        v-if="prices && materialAdded && dialog"
        :class="['name text-left', {'high': dialog}]"
      > 
        <span :class="{'no-refund': mzGrantUsed}">
          {{ $n(prices[materialType].price_brutto * quantity, 'currency', 'pl') }}
        </span>
        <span v-if="mzGrantUsed" class="ml-2 price-with-refund">
          {{ $n(prices[materialType].price_brutto * (quantity-1), 'currency', 'pl') }}
        </span>
        <span class="sublabel">
          ({{ $n(prices[materialType].price_brutto, 'currency', 'pl')}} {{$t('reservation.price_for_package_label')}})
        </span>
      </p>
      <span 
        v-if="(mzGrantFileId && !materialAdded) || mzGrantUsed"
        :class="['mz-package-label px-1 py-1 d-flex', {
          'mt-n6': !dialog || $vuetify.display.mobile && !materialAdded,
          'f-right': !materialAdded || !$vuetify.display.mobile
        }]"
      >
        <img :src="paidIcon" class="mr-1"/> {{ $t('mz.one_refund_package_label') }}
      </span>
    </div>
    <div class="order-1">
      <div class="label mt-6 mt-md-0" v-if="dialog">{{$t('reservation.quantity_label')}}</div>
      <v-text-field 
        v-model="quantity"
        class="mt-2 d-flex align-center set-quantity"
        type="number"
        min="0"
        :max="maxQuantity"
        :disabled="loading"
        label=""
        variant="plain"
        density="compact"
        hide-details="auto"
        v-if="!materialAdded || !dialog"
      >
        <template v-slot:prepend v-if="!materialAdded || !dialog">
          <v-btn
            icon
            variant="plain"
            size="default"
            :disabled="quantity <= 1 ? true : false"
            @click="quantity--"
          >
            <v-icon color="primary" size="24">mdi-minus</v-icon>
          </v-btn>
        </template>
        <template v-slot:append v-if="!materialAdded || !dialog">
          <v-btn
            icon
            variant="plain"
            size="default"
            :disabled="quantity >= maxQuantity ? true : false"
            @click="quantity++"
          >
            <v-icon color="primary" size="24">mdi-plus</v-icon>
          </v-btn>
        </template>
      </v-text-field>
      <div v-else class="" :class="{'high': dialog}">
        {{quantity}}
      </div>
    </div>
    <div class="label text-left mt-2" v-if="!dialog">
      {{$t('cart.available_number_of_packages_label')}} {{maxTrueReservationCount <= 0 ? 0 : maxTrueReservationCount}}
    </div>
    <v-card 
      v-if="canUseMzGrant() && !materialAdded"
      :class="['pa-4 mz-container d-flex align-center order-3', {
        'mt-6': !dialog,
        'mt-md-6 mt-5': mzGrantFileId && dialog,
        'mt-md-10 mt-9': !mzGrantFileId && dialog
      }]"
      outlined
      elevation="0"
      rounded="4"
      color="#F5F9FE"
    >
      <div>
        <div class="mz-title text-left">{{$t('mz.add_to_cart_title')}}</div>
        <div class="mz-text text-left mt-4">{{$t('mz.add_to_cart_text')}}</div>
        <template v-if="
          getFileMzGrant(materialType)?.treatment_location_name != donorDetails.material.location.city
          ">
          <div class="mz-title text-left mt-4 error ">
            {{$t('mz.wrong_material_location_header')}}
          </div>
          <div class="mz-text text-left error ">
            {{$t('mz.wrong_material_location_text_1', {
              location1: $t(donorDetails.material.location.city),
              location2: $t(getFileMzGrant(materialType)?.treatment_location_name)
            })}}
          </div>
          <div class="mz-text text-left error ">
            {{$t('mz.wrong_material_location_text_2')}}
          </div>
        </template>
      </div>
      <v-divider class="mx-4" color="#DADEE6" vertical></v-divider>
      <div>
        <a @click="toggleMzGrantFileId()" class="toggle-switch d-flex align-center">
          <label v-html="mzGrantFileId ? $t('mz.add_to_cart_label_on') : $t('mz.add_to_cart_label_off')"></label>
          <img :src="mzGrantFileId ? switchOnIcon : switchOffIcon" class="ml-2"/>
        </a>
      </div>
    </v-card>
    <div class="text-left order-4 flex-grow-1 d-flex flex-md-row-reverse flex-column-reverse justify-md-space-between justify-start w-100">
      <v-btn 
        class="mt-8 button add-to-cart align-self-end"
        :width="$vuetify.display.mobile || (!$vuetify.display.mobile && !dialog) ? '100%' : 'auto'"
        height="40"
        color="primary"
        rounded
        :disabled="loading || !quantity || maxTrueReservationCount <= 0"
        flat
        @click="addToCart()">
        <!-- <v-icon class="mr-4" size="24" :icon="loading ? 'mdi-loading mdi-spin' : basketIcon"></v-icon> -->
        <span v-if="materialAdded && dialog">{{$t('cart.go_next_btn')}}</span>
        <span v-if="!materialAdded || !dialog">{{$t('cart.choose_btn')}}</span>
      </v-btn>
      <v-btn
        class="button continue-shopping align-self-end"
        :width="$vuetify.display.mobile || (!$vuetify.display.mobile && !dialog) ? '100%' : 'auto'"
        height="40"
        rounded
        color="primary"
        @click="$emit('close')"
        v-if="materialAdded && dialog"
        variant="outlined">
          {{$t('cart.continue_searching_btn')}}
      </v-btn>
    </div>
  </v-card>

</template>

<script>
import axios from "axios";
import { mapGetters, useStore } from "vuex";
import { computed } from "vue";
import EmptyPhenotypeDialog from "./EmptyPhenotypeDialogComponent";

export default {
  name: 'addToCartComponent',
  props: {
    donorDetails: Object,
    maxTrueReservationCount: Number,
    age: Number,
    dialog: {
      type: Boolean,
      default: false
    },
    isMaterialAdded: {
      type: Boolean,
      default: false
    },
    isMzGrantUsed: {
      type: Boolean,
      default: false
    },
    selectedQuantity: {
      type: Number,
      default: 1
    }
  },
  emits: ['close'],
  components: {
    EmptyPhenotypeDialog
  },
  data() {
    return {
      prices: null,
      quantity: this.selectedQuantity,
      loading: false,
      basketIcon: 'basket-outline white',
      materialAdded: this.isMaterialAdded,
      emptyPhenotypeOpen: false,
      mzGrantFileId: null,
      wantMzGrant: false,
      mzGrantUsed: this.isMzGrantUsed
    }
  },
  setup() {
    const store = useStore()
    const oidcUser = computed(() => store.getters['oidcStore/oidcUser'])
    const storedPhenotype = computed(() => store.getters['phenotypeModule/getPhenotype'])


    const paidIcon = computed({
      get: () => { return require('@/assets/icons/paid.svg');}
    })
    const switchOnIcon = computed({
      get: () => { return require('@/assets/icons/switch-on.svg');}
    })
    const switchOffIcon = computed({
      get: () => { return require('@/assets/icons/switch-off.svg');}
    })

    return {
      oidcUser,
      storedPhenotype,
      paidIcon,
      switchOnIcon,
      switchOffIcon,
      hasPhenotypeMode: (mode) => store.getters["phenotypeModule/hasPhenotypeMode"](mode),
      getFileMzGrant: (materialType) => store.getters["fileMTModule/getFileMzGrantByMaterialType"](materialType),
      getCartMzGrantItems: computed(() => store.getters["cartModule/getMzItems"])
    }
  },
  computed: {
    maxQuantity() {
      if (this.maxTrueReservationCount < 0) {
        return 0;
      }

      if (this.materialType == 'mtCell') {
        return this.maxTrueReservationCount > this.getConfig.material_quantity_cell_limit ? this.getConfig.material_quantity_cell_limit : this.maxTrueReservationCount;
      } else {
        return this.maxTrueReservationCount > this.getConfig.material_quantity_semen_limit ? this.getConfig.material_quantity_semen_limit : this.maxTrueReservationCount;
      }
    },
    materialType() {
      return this.donorDetails.material.type
    },
    materialLocation() {
      return this.donorDetails.material.location.city
    },
    materialLocationId() {
      return this.donorDetails.material.location.id
    },
    ...mapGetters('cartModule', ['getCount', 'getConfig'])
  },
  created() {
    this.$watch('quantity', (quantity) => {
      this.validateQuantity(quantity)
    })
  },
  mounted() {
    this.getMaterialPrices()
    this.toggleMzGrantFileId()
  },
  methods: {
    canUseMzGrant() {
      let fileMzGrant = this.getFileMzGrant(this.materialType)
      let cartMzGrantItemsKeys = Object.keys(this.getCartMzGrantItems)
      if (fileMzGrant) {
        if (!cartMzGrantItemsKeys.length) {
          return true
        } else {
          let cartMzGrantItem = this.getCartMzGrantItems[cartMzGrantItemsKeys[0]]
          return cartMzGrantItem?.mz_grant_file_id == fileMzGrant.file_id 
            && cartMzGrantItem?.material_type != this.materialType
        }
      } else {
        return false
      }
    },
    toggleMzGrantFileId() {
      if (!this.mzGrantFileId) {
        let fileMzGrant = this.getFileMzGrant(this.materialType)
        if (this.canUseMzGrant() && fileMzGrant?.treatment_location_name == this.donorDetails.material.location.city) {
          this.mzGrantFileId = fileMzGrant.file_id
          this.wantMzGrant = true;
        }
      } else {
        this.mzGrantFileId = null
        this.wantMzGrant = false;
      }
    },
    getMaterialPrices() {
      axios
        .get(`/api/donor/material_price`)
        .then((response) => {
          this.prices = response.data
        })
        .catch(err => {
          console.error(err);
        })
    },
    validateQuantity(quantity) {
      if (quantity > this.maxQuantity) {
        this.quantity = this.maxQuantity
      } else if (quantity < 1) {
        this.quantity = 1
      }
    },
    addToCart() {
      if (this.materialAdded && this.dialog) {
        this.$router.push({name: 'cartView'});
        this.$emit('close');
        return;
      }
      if (!this.materialAdded) {
        if (!this.hasPhenotypeMode('own') || !this.hasPhenotypeMode('partner')) {
          this.emptyPhenotypeOpen = true;
          return false;
        }
      }
      if (this.quantity && this.quantity <= this.maxQuantity) {
        this.loading = true

        // check also addItem, removeItem (CartComponent) and updateCartItem (reservation_util.js) if modify /api/cart
        axios
          .post(`/api/cart`, {
            "items": {
              [this.donorDetails.id]: {
                "mz_grant_file_id": this.mzGrantFileId,
                "want_mz_grant": this.wantMzGrant,
                "age": this.age,
                "material_type": this.materialType,
                "material_location_name": this.materialLocation,
                "material_location_id": this.materialLocationId,
                "quantity": this.quantity,
                "price": this.prices[this.materialType].price_brutto,
                "price_id": this.prices[this.materialType].item_id,
                "price_name": this.prices[this.materialType].price_name,
                ...(this.materialType == 'mtSemen' && {procedure: this.donorDetails.material.fitness_for_insemination})
              }
            }
          })
          .then(() => {
            this.basketIcon = 'mdi-basket-check-outline'
            this.materialAdded = true;
            this.mzGrantUsed = this.mzGrantFileId ? true : false;
            this.$emit('confirmed');
            this.$emit('setSelectedQuantity', this.quantity);
            this.$emit('setMzGrantUsed', this.mzGrantUsed);
            // this.$store.dispatch('cartModule/setCount', this.getCount + 1);
            this.$store.dispatch('cartModule/fetchCart');

            if (this.mzGrantUsed) {
              let cartMzGrantItems = this.getCartMzGrantItems;
              cartMzGrantItems[this.donorDetails.id] = {
                "mz_grant_file_id": this.mzGrantFileId,
                "material_type": this.materialType
              }
              this.$store.dispatch('cartModule/setMzItems', cartMzGrantItems);
            }

            this.$gtag.event('donor', {
              'donor_product_key': this.donorDetails.id,
              'donor_material_type': this.materialType,
              'donor_event_value': 'add to cart'
            })
          })
          .catch(err => {
            if (err.response) {
              console.error(err.response.data);
              if (err.response.data.error_key == 'CART_ITEMS_LIMIT') {
                if (this.dialog) {
                  this.$emit('close')
                }
                this.$nextTick(() => {
                  this.$root.$alertMessageRef.showAlert(
                    this.$t(`alert.CART_ITEMS_LIMIT.title`, {'material_type': this.$t(`donor.${this.materialType}.gen`)}),
                    this.$t(`alert.CART_ITEMS_LIMIT.message`, {'limit': 4, 'material_type': this.$t(`donor.${this.materialType}.gen`)}),
                    {
                      link: true,
                      linkRouteName: 'cartView',
                      linkText: this.$t('reservation.list.go_to_reservation_list_btn'),
                      backgroundColor: 'rgb(254,245,228)',
                      borderColor: 'rgb(255, 230, 100)',
                      timeout: false,
                      iconColor: 'rgba(249, 193, 0, 1)',
                      icon: 'mdi-information-outline',
                      width: 'auto'

                    }
                  )
                })
              }
              if(err.response.data.error_key == 'CART_CONSTRAINT') {
                if (this.dialog) {
                  this.$emit('close')
                }
                this.$nextTick(() => {
                  Promise.all([
                    axios.get('/api/reservation'),
                    axios.get('/api/cart')
                  ]).then((response) => {
                    let reservations = response[0].data.reservations;
                    let elementsInReservations = reservations.filter(e => ((e.status == 'PROCESSED') ||
                    e.status == 'CREATED'))?.length || 0;
                    
                    let on_reservation = elementsInReservations ? 'RESERVATION_' : ''

                    this.$root.$alertMessageRef.showAlert(
                      this.$t(`alert.CART_ITEMS_${on_reservation}CONSTRAINT.title`, {
                        'material_type': this.$t(`donor.${this.materialType}.next`)
                        
                      }),
                      this.$t(`alert.CART_ITEMS_${on_reservation}CONSTRAINT.message`, {
                        'material_count': this.$t(`donor.${this.materialType}.single`)
                      }),
                      {
                        link: true,
                        linkRouteName: elementsInReservations ? 'dashboardView' : 'cartView',
                        linkQuery: 'reservations',
                        linkText: this.$t('reservation.list.go_to_reservation_list_btn'),
                        backgroundColor: 'rgb(254,245,228)',
                        borderColor: 'rgb(255, 230, 100)',
                        timeout: false,
                        iconColor: 'rgba(249, 193, 0, 1)',
                        icon: 'mdi-information-outline',
                        width: '800px'

                      }
                    )
                  }) ;
                })
              }
            }
            this.basketIcon = 'mdi-basket-remove-outline'
            this.materialAdded = false;
          })
          .finally(() => {
            this.loading = false
          });
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .desc {
    font-size: 12px !important;
  }

  .order-2 {
    min-width: 160px;
  }

  a.toggle-switch {
    min-width: 68px;
    label {
      cursor: pointer;
      @include nsb-font-container;
      font-size: 14px;
      line-height: normal;
    }
    img {
      cursor: pointer;
      height: 16px;
    }
  }

  .cart_container {
    background: white !important;
  }
  .mz-container {
    border: 1px solid $ds-primary-6;
    .mz-title {
      @include nsb-font-header-bold;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
    .mz-text {
      @include nsb-font-container;
      line-height: 18px;
    }
    .error {
      color: var(--Text-status-error, #D6001C);
    }
  }
  .mz-package-label {
    @include nsb-font-container;
    line-height: normal;
    border-radius: 100px;
    background: #F0FFF3;
    color: #0DA531;
    width: max-content;
    &.f-right {
      float: right;
    }
  }
  .v-card {
    margin-bottom: 32px;
    p {
      @include nsb-font-container;
      font-size: 14px;
      line-height: 21px;
    }
  }
  .no-refund {
    line-height: normal;
    color: $ds-primary-100;
    font-size: 12px !important;
    text-decoration: line-through;
  }
  .price-with-refund {
    line-height: normal;
    color: $ds-primary;
    font-size: 16px !important;
  }
  .name {
    @include nsb-font-header;
    font-size: 16px !important;
  }
  .bold {
    @include nsb-font-header-bold;
    font-size: 14px;
    line-height: 21px;
  }
  .v-input.set-quantity {
    // background-color: $nsb-background;
    width: 144px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid $nsb-color-3;
    --v-input-control-height: 40px;
    --v-input-padding-top: 0px;
    :deep(.v-field__input) {
      color: $ds-primary; 
      font-size: 14px !important;
      line-height: 21px;
      // width: 48px;
      text-align: center;

      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
      &[type=number] {
        -moz-appearance: textfield;
      }
    }
    .v-btn {
      opacity: 1;
      &.v-btn--disabled {
        opacity: 0.1;
      }
    }
  }

  .v-btn {
    &.button {
      @include nsb-font-button;
      font-size: 14px !important;
      line-height: 21px;
    }
    &.add-to-cart {
      :deep(.v-btn__overlay) {
        opacity: 0 !important;
      }
    }
    &.continue-shopping {
      border-color: $ds-primary;
    }
  }

  .id-wrapper {
    .label {
        @include nsb-font-header;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary;
    }
    .id {
        @include nsb-font-container;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary;
        border-radius: 12px;
        background-color: $ds-primary-9;
        display: inline-block;
        padding: 1.5px 12px;
    }
  }
  .main-header {
    @include nsb-gentium-bold;
    font-size: 21px;
    line-height: 27px;
    width: 100%;
    font-weight: normal;
  }
  .label {
    @include nsb-select-placeholder;
    font-size: 12px;
    line-height: normal;
    color: $ds-primary-100;
  }
  .sublabel {
    @include nsb-font-label;
    font-size: 10px;
  }
  .wide {
    width: 588px !important;
  }

  .high {
    line-height: 48px !important;
  }

  @media (min-width: 960px) {
    .v-card {
      margin-bottom: unset;
    }
  }
</style>